import { IChargePointConnector } from '../common/hooks/useChargePoint'

export const isLeftConnector = (connectorId?: number) => connectorId === 1

// TODO: Add typing for [connectors]
const findLeftConnector = (connectors: Array<IChargePointConnector>): IChargePointConnector | null => {
    if (!connectors || !connectors.length) return null
    return connectors.find((connector) => isLeftConnector(connector.connectorId)) || null
}

export default findLeftConnector
